// landIeul: pages/_app.tsx の Sentry.init (@sentry/react) 相当。
// DSN / 環境名はレイアウト (layouts/site.slim) が <meta name="sentry-dsn|sentry-environment"> で埋め込む。
// Next の NEXT_PUBLIC_SENTRY_DSN と Rails の TOTTY_SENTRY_DSN は同じ SSM パラメータ (同一 Sentry プロジェクト) なので、
// Rails 側の環境変数をそのまま流用する。meta が無い環境 (development / test) では初期化しない。
import * as Sentry from "@sentry/browser";

const readMeta = (name: string): string | undefined =>
  document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content || undefined;

const dsn = readMeta("sentry-dsn");
if (dsn) {
  Sentry.init({ dsn, environment: readMeta("sentry-environment") });
}
